import { format, isValid, parseISO } from 'date-fns';

import { abbreviatedNumber } from './abbreviatedNumber';

export const formatChartXTick = (date: string, isHourlyData = false) => {
  const parsedDate = parseISO(date);

  if (!isValid(parsedDate)) return '';

  // For hourly data (NRT), show time: "h:mm a"
  // For daily data (Fact), show date: "MMM d" (e.g., "Jan 15")
  return isHourlyData ? format(parsedDate, 'h:mm a') : format(parsedDate, 'MMM d');
};

export const formatChartYTick = (value: number) => abbreviatedNumber(value, { fractionSize: 0 });

export const generateDateRangeCaption = data => {
  const range = [data[0], data.at(-1)]
    .map(item => {
      if (!item?.timestamp) return null;
      const parsedDate = parseISO(item.timestamp);

      return isValid(parsedDate) ? parsedDate : null;
    })
    .filter((date): date is Date => date !== null);

  const months = [...new Set(range.map(date => format(date, 'MMMM')))];
  const days = [...new Set(range.map(date => format(date, 'd')))];

  let caption = `${months[0]} ${days[0]}`;
  if (months.length > 1) {
    caption = `${months[0]} ${days[0]} - ${months[1]} ${days[1]}`;
  } else if (days.length > 1) {
    caption = `${months[0]} ${days[0]} - ${days[1]}`;
  }

  return caption;
};
